module.exports = __webpack_public_path__ + "static/media/Brochure3.2f8285b1.png";